/** Reorder list after HTML5 drop on row `hoverIndex` (see `exercise-edit.html`). */
export function reorderStepRows<T>(rows: T[], from: number, hoverIndex: number, insertBefore: boolean): T[] {
  if (from === hoverIndex) return [...rows];
  const result = [...rows];
  const [removed] = result.splice(from, 1);
  let insertAt = insertBefore ? hoverIndex : hoverIndex + 1;
  if (from < hoverIndex) insertAt -= 1;
  insertAt = Math.max(0, Math.min(insertAt, result.length));
  result.splice(insertAt, 0, removed);
  return result;
}
